import { Badge } from "@/components/ui/badge"
import { formatDateTime2 } from "@/utils/format-date"
import { numberToCurrency } from "@/utils/money"
import { getStatusBadgeConfig } from "@/utils/status-badge"
import { ColumnDef } from "@tanstack/react-table"
import { parse } from "date-fns"

const DATE_FORMATS = ["dd/MM/yyyy HH:mm:ss", "dd/MM/yyyy HH:mm", "dd/MM/yy HH:mm:ss", "dd/MM/yy HH:mm"]

function renderDataHora(raw: unknown): string {
    if (raw == null || raw === "") return "-"
    const formatted = formatDateTime2(raw as string, { includeSeconds: true })
    if (formatted !== "-") return formatted
    if (typeof raw === "string") {
        for (const fmt of DATE_FORMATS) {
            const parsed = parse(raw, fmt, new Date())
            if (!isNaN(parsed.getTime())) {
                return formatDateTime2(parsed, { includeSeconds: true })
            }
        }
        return raw
    }
    return String(raw)
}

export interface Transaction {
    Empresa: string
    Loja: string
    "Nome Loja": string
    CNPJ: string
    PDV: string
    "Data/Hora": string
    NSU: string
    Cupom: string
    Rede: string
    Cartão: string
    Transação: string
    Valor: string
    Ação: string
    Status: string
}

export const columns: ColumnDef<Transaction>[] = [
    {
        accessorKey: "Loja",
        header: "Loja",
        filterFn: "includesString",
        cell: ({ row }) => (
            <div className="font-medium">{row.getValue("Loja")}</div>
        ),
    },
    {
        accessorKey: "Nome Loja",
        header: "Nome da Loja",
        cell: ({ row }) => <div>{row.getValue("Nome Loja")}</div>,
    },
    {
        accessorKey: "PDV",
        header: "PDV",
        filterFn: "includesString",
        cell: ({ row }) => <div>{row.getValue("PDV")}</div>,
    },
    {
        accessorKey: "Data/Hora",
        header: "Data/Hora",
        cell: ({ row }) => <div>{renderDataHora(row.getValue("Data/Hora"))}</div>,
    },
    {
        accessorKey: "NSU",
        header: "NSU",
        filterFn: "includesString",
        cell: ({ row }) => <div>{row.getValue("NSU")}</div>,
    },
    {
        accessorKey: "Valor",
        header: "Valor",
        cell: ({ row }) => {
            const value = parseFloat(row.getValue("Valor"))
            return <div>{numberToCurrency(value)}</div>
        },
    },
    {
        accessorKey: "Rede",
        header: "Rede",
        cell: ({ row }) => <div>{row.getValue("Rede")}</div>,
    },
    {
        accessorKey: "Status",
        header: "Status",
        cell: ({ row }) => {
            const status = row.getValue("Status") as string
            const statusConfig = getStatusBadgeConfig(status)
            return (
                <Badge variant={statusConfig.variant} className={`${statusConfig.className} text-white ${status === 'Descartar' ? 'bg-red-500' : 'bg-green-500'}`}>
                    {statusConfig.text}
                </Badge>
            )
        },
    },
]
